import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$futureOrderingEnablePickup',
  initialState,
  reducers: {
    setFutureOrderingEnablePickup(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setFutureOrderingEnablePickup } = slice.actions;
export default slice.reducer;
